var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVegetarian = function SvgVegetarian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vegetarian-icon-group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vegetarian-icon-wrapper",
    transform: "translate(-189.000000, -211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-vegetarian",
    transform: "translate(69.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.000000, 2.000000)",
    id: "Vegetarian",
    fill: "#682C88"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.07366319 7.33259374 5.77235412 7.33259374 8.11271356 14.718438 8.13667628 14.718438 10.5329487 7.33259374 12.1917018 7.33259374 8.99667184 16.6674063 7.18349235 16.6674063"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.1182605 7.33259374 19.835811 7.33259374 19.835811 8.7463945 14.7503883 8.7463945 14.7503883 11.2012425 19.4550699 11.2012425 19.4550699 12.532505 14.7503883 12.532505 14.7503883 15.2536055 19.9263368 15.2536055 19.9263368 16.6674063 13.1182605 16.6674063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,24 C5.372583,24 -3.78367554e-15,18.627417 -3.78367554e-15,12 C-3.78367554e-15,5.372583 5.372583,-3.78367554e-15 12,-3.78367554e-15 C18.627417,-3.78367554e-15 24,5.372583 24,12 C23.9926632,18.6243756 18.6243756,23.9926632 12,24 Z M12,0.950521411 C5.89754148,0.950521411 0.950521411,5.89754148 0.950521411,12 C0.950521411,18.1024585 5.89754148,23.0494786 12,23.0494786 C18.1024585,23.0494786 23.0494786,18.1024585 23.0494786,12 C23.0436075,5.89997501 18.100025,0.956392469 12,0.950521411 Z",
    id: "Shape"
  })))))));
};
export default SvgVegetarian;